import React from 'react';
import { PropertyImageGalleryProps } from '../../../component-props';
import { Image, LayoutContainer } from '@greystar/designsystem';
import { PropertyImage } from '@greystar/lib';

interface ImageType {
  src: string;
  alt?: string;
}
const transformProps = (images: PropertyImage[]): ImageType[] => {
  const transformedImages: ImageType[] = [];

  images.forEach((image) => {
    transformedImages.push({
      src: image.url,
      alt: image.alt,
    });
  });

  return transformedImages;
};

export const PropertyImageGallery = (props: PropertyImageGalleryProps): JSX.Element => {
  const transformedImages = props && props.images && transformProps(props.images);

  return (
    <LayoutContainer flexDirection="column">
      <div>
        {transformedImages?.map((image) => (
          <div key={image.src} style={{ width: '400px', height: '500px', display: 'inline' }}>
            <Image
              borderType="left" // sides , bottom , right , left
              borderColour="sky" // jade , terracotta , sky , sunshine
              key={image.alt}
              src={image.src}
              alt={image.alt}
            />
          </div>
        ))}
      </div>
    </LayoutContainer>
  );
};
